// src/pages/Profile/components/ProfileSidebar.jsx

import React from "react";
import { FaCamera, FaUserCircle } from "react-icons/fa";

import { cn } from "../utils/profileUtils";

export default function ProfileSidebar({
  previewSrc,
  displayName,
  email,
  roleMeta,
  imgVersion,
  imgOk,
  setImgOk,
  openPhotoModal,
}) {
  const RoleIcon = roleMeta.icon;

  return (
    <aside className="relative bg-slate-950/75 p-6 sm:p-8 lg:p-10">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(242,113,49,0.30),transparent_36%),radial-gradient(circle_at_bottom_right,rgba(59,130,246,0.18),transparent_36%)]" />

      <div className="relative flex h-full flex-col items-center justify-center text-center">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-primary/30 blur-3xl" />

          <img
            key={imgVersion}
            src={previewSrc}
            alt="Avatar de l'utilisateur"
            className="relative h-36 w-36 rounded-full border-4 border-white/20 bg-white object-cover shadow-2xl sm:h-44 sm:w-44"
            onError={() => setImgOk(false)}
          />

          <button
            type="button"
            onClick={openPhotoModal}
            className="absolute bottom-2 right-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white shadow-xl transition hover:scale-105 hover:brightness-110"
            aria-label="Modifier la photo"
          >
            <FaCamera />
          </button>
        </div>

        {!imgOk && (
          <div className="mt-4 rounded-full border border-red-500/20 bg-red-500/10 px-4 py-2 text-xs font-bold text-red-200">
            Impossible de charger l’image.
          </div>
        )}

        <div className="mt-7 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-white/70 backdrop-blur-xl">
          <FaUserCircle className="text-primary" />
          Profil utilisateur
        </div>

        <h1 className="mt-5 font-barlow text-4xl font-bold leading-tight text-white sm:text-5xl">
          {displayName}
        </h1>

        <p className="mt-3 break-all text-sm font-semibold text-white/60">
          {email}
        </p>

        <div
          className={cn(
            "mt-5 inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-bold",
            roleMeta.badge
          )}
        >
          <RoleIcon />
          {roleMeta.label}
        </div>
      </div>
    </aside>
  );
}